import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

export const chatsUnreadCountQueryKey = ['hami', 'chats-unread-count'] as const;

/** Total unread chat messages of the signed-in user (Hami reads the session cookie). */
export const getChatsUnreadCount = async (): Promise<number> => {
  const { data } = await axios.get<{ total?: number }>('https://hami-back.paziresh24.com/api/external/tickets/unread-count', {
    withCredentials: true,
    timeout: 4000,
  });
  const total = Number(data?.total);
  return Number.isFinite(total) && total > 0 ? total : 0;
};

/**
 * Badge count for «گفت‌وگوها» in the bottom navigation; 0 when signed out or Hami is unreachable.
 * Every call costs Hami an auth round-trip, so: one request per minute at most on remount/focus,
 * a poll every two minutes only while the page is visible, and nothing at all when disabled
 * (desktop, where the bottom navigation is hidden).
 */
export const useChatsUnreadCount = (enabled: boolean) => {
  const query = useQuery(chatsUnreadCountQueryKey, getChatsUnreadCount, {
    enabled,
    staleTime: 60_000,
    refetchInterval: 120_000,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true,
    retry: false,
  });
  return { ...query, count: enabled ? query.data ?? 0 : 0 };
};
